import { SalesOrderContractTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1770. 受注案件契約タスクコメント一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/sales_order_contract_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const salesOrderContractTaskComments = (props: Props): Promise<SalesOrderContractTaskComment[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/sales_order_contract_task_comments`
  );
};

export const useSalesOrderContractTaskComments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => salesOrderContractTaskComments(props),
  });
};

export const useSalesOrderContractTaskCommentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'sales_orders',
    props.sales_order_id,
    'sales_order_contract_tasks',
    props.task_id,
    'sales_order_contract_task_comments',
  ];
};
